const getPaginationCurrentPageAfterRemoval = (params) => {
    const { currentPage, perPage, total, removedCount = 1 } = params;
    if (perPage <= 0)
        return 0;
    const newTotal = Math.max(0, total - removedCount);
    const lastPage = Math.max(0, Math.ceil(newTotal / perPage) - 1);
    return Math.min(currentPage, lastPage);
};
export default getPaginationCurrentPageAfterRemoval;
